type FieldNames<T extends string> = {
    [K in T]: K
}

type FormDataObjectWithoutFile<T extends string> = Record<T, string>

export const genFieldNames = <T extends string>(arr: T[]) => {
    return {
        fieldNames: Object.fromEntries(arr.map(e => [e, e])) as FieldNames<T>,
        getFormData: (element: HTMLFormElement) => {
            return Object.fromEntries(
                new FormData(element)
            ) as FormDataObjectWithoutFile<T>
        }
    }
}
